export const areaRevealSelector = [
  '.mv', '.submv', '.topics > article', '.rail-inner > div:not([hidden])',
  '.approach .section-head', '.process article', '.works .section-head',
  '.featured .feature', '.work-list > article:not(.blank)',
  '.services .section-head', '.service-list > article',
].join(', ');

// 寸法・位置を変えず、初めて画面に入る各エリアを左上から右下へ開く。
export function initAreaReveal(areas, {
  root, reducedMotion, random = Math.random, Observer = globalThis.IntersectionObserver,
  onActivityChange = () => {},
  onReveal = () => {},
}) {
  if (reducedMotion.matches || !Observer) return () => {};
  const pending = new Map();
  const active = new Set();
  const mediaListeners = [];
  const finish = (area) => {
    const classes = pending.get(area);
    if (!classes) return;
    area.classList.remove(...classes, 'is-area-revealing');
    area.removeEventListener('animationend', onEnd);
    area.removeEventListener('animationcancel', onEnd);
    area.removeEventListener('focusin', onFocus);
    observer.unobserve(area);
    pending.delete(area);
    onReveal(area);
    if (active.delete(area) && active.size === 0) onActivityChange(false);
  };
  const onEnd = (event) => {
    if (event.target === event.currentTarget && event.animationName === 'area_inset_in') finish(event.currentTarget);
  };
  const onFocus = (event) => finish(event.currentTarget);
  const observer = new Observer((entries) => {
    entries.forEach((entry) => {
      if (!pending.has(entry.target) || !entry.isIntersecting || entry.intersectionRatio < .01) return;
      const movie = entry.target.matches?.('.mv') && entry.target.querySelector('video:not([hidden])');
      // 通常は動画の準備を待つ。再生不可時は既存画像への切替通知で待機を解除する。
      if (movie && !movie.error && movie.readyState < 3) {
        observer.unobserve(entry.target);
        const onReady = () => {
          movie.removeEventListener('canplay', onReady);
          movie.removeEventListener('error', onReady);
          movie.removeEventListener('ffd:mvfallback', onReady);
          if (pending.has(entry.target)) observer.observe(entry.target);
        };
        movie.addEventListener('canplay', onReady, { once: true });
        movie.addEventListener('error', onReady, { once: true });
        movie.addEventListener('ffd:mvfallback', onReady, { once: true });
        mediaListeners.push(() => {
          movie.removeEventListener('canplay', onReady);
          movie.removeEventListener('error', onReady);
          movie.removeEventListener('ffd:mvfallback', onReady);
        });
        return;
      }
      if (active.has(entry.target)) return;
      active.add(entry.target);
      if (active.size === 1) onActivityChange(true);
      entry.target.classList.add('is-area-revealing');
      observer.unobserve(entry.target);
    });
  }, { root, threshold: .01 });
  for (const area of new Set(areas)) {
    if (area.closest('[hidden]')) continue;
    const delay = Math.min(5, 1 + Math.floor(random() * 5));
    const classes = ['area-reveal', `area-delay-${delay}`];
    pending.set(area, classes);
    area.classList.add(...classes);
    area.addEventListener('animationend', onEnd);
    area.addEventListener('animationcancel', onEnd);
    area.addEventListener('focusin', onFocus);
    observer.observe(area);
  }
  const destroy = () => {
    mediaListeners.forEach((remove) => remove());
    observer.disconnect();
    for (const area of pending.keys()) finish(area);
    reducedMotion.removeEventListener('change', onMotion);
  };
  const onMotion = () => { if (reducedMotion.matches) destroy(); };
  reducedMotion.addEventListener('change', onMotion);
  return destroy;
}
